define('views/parts/media-info-box',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/menu/menu-context',
    // templates
    'text!templates/parts/media-info-box.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VMenuContext,
    // templates
    TMediaInfoBox
) {

    var VMediaInfoBox = Backbone.Epoxy.View.extend({
        className: "media-info-box white-box",
        template: TMediaInfoBox,
        events: {
            'click': 'onClick',
            'click .options-toggle': 'onMenuOptionToggle',
        },
        regions: {
            menu: ".menu-options",
            content: ".media-info-content",
            photo: ".photo",
            extraPhoto: ".extra-photo-content"
        },

        initialize: function(opt) {
            opt = opt || {};
            this.options = _.extend({
                menu: true,
                empty: !opt.title && !opt.subtitle && !opt.tinyinfo
            }, opt);

            this.view = {};
        },

        render: function() {
            // Render Template HTML with Mustache
            var html = Mustache.render(this.template, Mustache.getContext(this.options), {
                customTitle: this.options.customTitle,
                extraContent: this.options.extraContent,
                customSubtitle: this.options.customSubtitle,
                fromNow: _.isEmpty(this.options.timeago) ? null : this.options.timeago.fromNow,
                timestamp: _.isEmpty(this.options.timestamp) ? null : this.options.timeago.timestamp,
            });
            //class management for unread conversation
            if (this.model.get("folder") !== undefined) { //if (typeof this.model.isRead() !== "undefined") {
                if (this.model.isRead() === false) {
                    this.$el.addClass('unread');
                }
            }
            this.$el.empty().append(html);

            this.generateZones()
                .applyBindings();

            return this; // Chaining view calls, good convention http://backbonejs.org/#View-render
        },

        setContent: function(html) {
            var zone = this.zone;
            if (zone) {
                zone.$content.empty().append(html);
            }
        },

        setPhoto: function(src) {
            this.zone.$photo.attr('src', src);
        },

        setExtraPhotoContent: function(html) {
            var zone = this.zone;
            if (zone) {
                zone.$extraPhoto.empty().append(html);
            }
        },

        enableMenu: function(val) {
            this.options.menu = _.isUndefined(val) ? true : Boolean(val);
            if (this.zone) {
                this.render();
            }
        },

        getMenu: function() {
            if (this.zone) {
                return this.zone.$menu;
            }
        },

        setActive: function(val) {
            this.$el.toggleClass('active', val);
        },

        setMenuCollection: function(collection) {
            this.collection = collection;
            this.newMenuNeeded = true
        },

        /**
         * You must provide 'menu' options object.
         */
        onMenuOptionToggle: function(e) {
            e.preventDefault();
            if (!this.view.menu || this.newMenuNeeded) {
                this.newMenuNeeded = false
                var menu = this.options.menu,
                    context = this.options.context;

                if (!this.collection && menu.init) {
                    this.collection = _.callback(context, menu.init);
                }

                this.view.menu = new VMenuContext(_.extend({
                    collection: this.collection,
                    context: context,
                    onClick: this.onMenuOptionClick.bind(this),
                }, menu));
                this.assign(this.view.menu, this.zone.$menu);
            }
            this.view.menu.toggle();
        },

        onMenuOptionClick: function(e) {
            e.stopPropagation();
        },

        onClick: function(e) {
            if (this.$(e.target).hasClass('options-toggle')) {
                return;
            }
            //class management for unread conversation
            if (this.model.get("folder") !== undefined) {  //if (typeof this.model.isRead() !== "undefined") {
                this.$el.removeClass('unread');
            }

            _.callback(this.options.context, this.options.onClick, [e]);
            this.trigger("click", e);
        }

    });

    return VMediaInfoBox;
});

